import { useMutation } from '@tanstack/react-query'

import { useApi } from 'hooks'
import { RECAPTCHA_TYPES } from 'config/constants'

const useResendCode = () => {
  const { apiFetch } = useApi()

  const resendCode = ({ email, method }) => {
    return apiFetch({
      url: `/auth/resendcode/${method || 'sms'}`,
      method: 'POST',
      data: { email },
      captcha: {
        type: RECAPTCHA_TYPES.capjs,
        action: 'resendcode_web',
      },
    })
      .then(res => res.data)
  }


  const {
    mutate,
    ...rest
  } = useMutation(resendCode)

  return {
    resendCode: mutate,
    ...rest,
  }
}

export default useResendCode
